import { render, staticRenderFns } from "./CompanyLanding.vue?vue&type=template&id=da4a38ba&scoped=true"
import script from "./CompanyLanding.vue?vue&type=script&lang=js"
export * from "./CompanyLanding.vue?vue&type=script&lang=js"
import style0 from "./CompanyLanding.vue?vue&type=style&index=0&id=da4a38ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4a38ba",
  null
  
)

export default component.exports